import { render, staticRenderFns } from "./project_details.vue?vue&type=template&id=0d48454f"
import script from "./project_details.vue?vue&type=script&lang=js"
export * from "./project_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports